import OccupationStatus from "@my-pages/features/employment/components/Occupation/OccupationStatus.tsx";
import {IOccupationalStatusProps} from "@my-pages/features/employment/types";

const UpComingOccupation = ({occupationStatus}: IOccupationalStatusProps) => {
    return (<div className="card border border-dashed border-2 h-100">
        <div className="card-body">
            <div className="kicker mb-2">Kommande status</div>
            <OccupationStatus occupationStatus={occupationStatus}/>
        </div>
    </div>)
}

export default UpComingOccupation;